<template>
  <pbc-overlay ref='modal'
               @close="onClose"
               :disable-title="true"
               @done='onAddBackground'>
    <template #default="{}">
      <div class="h-full flex flex-col">
        <div class="h-48 flex-none flex flex-col relative">
          <editor-player ref='player'
                        class='w-full relative h-full flex flex-none'
                        :transforms-and-source='transformsAndSource'
                        :gamedata='transformsAndSource.gamedata.gamedata' 
                        :enable-toolbar='false'
                        :block-pan='true'>
          </editor-player>
          <portal-target class="w-32 absolute left-0 top-0 bottom-0 flex flex-col justify-center my-rotate-90" name='testit' />
          <fill-loader v-if='waitingForBackgroundToLoad' />
        </div>
        <div class="mx-0 md:mx-64 flex justify-center">
          <pbc-toggle-button v-model='isColor' class="w-24 text-sm my-2" mode='outline'>
            <span class="mx-auto">Color</span>
          </pbc-toggle-button>
          <pbc-toggle-button v-model='isImage' class="w-24 text-sm  my-2" mode='outline'>
            <span class="mx-auto">Image</span>
          </pbc-toggle-button>
        </div>

        <div v-if='isColor' class="overflow-scroll">
          <div class="h-64 p-2 grid grid-cols-4 gap-1">
            <button @click='clearBackground' class="text-xs transparent-button">
              None
            </button>

            <button class="transparent-button"
                    v-for='color in colors'
                    @click='selectColor(color)'
                    :key='color'
                    :style='{"background-color":color}'
                    >
            </button>
          </div>
        </div>

        <div v-if='isImage'>
          <background-animator v-if='!waitingForBackgroundToLoad'
                              :background-info='backgroundInfo'
                              :partutil='partutil'
                              :render-tools='renderTools' 
                              @restart='onRestart'
                              />

       </div>

        <div v-if='isImage' class="grow overflow-y-scroll overflow-x-hidden">

          <image-uploader class="w-full shadow rounded"
                          game-id='gameId'
                          @uploaded='onUpload'
                          :is-short-mode='true'
                          :already-uploaded='uploadedImages'
                          @select='onSelectUploadedImage'
                          />
           <apollo-query :query='listPacksQuery'
                      class='instant-view-spritesheet-top-grid'
                      fetch-policy='cache-and-network'
                      :variables='{from:0,size:100}'>
            <template v-slot='{ result: { loading, error, data }, isLoading }'>
            <fill-loader v-if='loading || isLoading' />
              <!--
              <div v-if='waitingForBackgroundToLoad || isLoading || loading' class="spinner text-xl mt-8 mb-4 mx-auto" />
              -->

              <div class="instant-choose-pack-vertical">
                <instant-view-spritesheet v-for='(background,i) in getBackgroundsFromPacks(((data||{}).getPacks||{}).items||[])'
                                          ref='instantViewSpritesheet'
                                          :spritesheet='background.id'
                                          type='big'
                                          class="mx-0 my-0"
                                          :key='i'
                                          @select='onSelectBackgroundImage'
                                          >
                <template v-if='i === 0' #before='{}'>
                </template>
              </instant-view-spritesheet>
              </div>


              </template>
          </apollo-query>

        </div>

      </div>
    </template>
  </pbc-overlay>

</template>
<script>
import ImageUploader from '@ui/molecules/ImageUploader.vue';
import colors from '@edit/colors.js';
import { types } from '@edit/tree/componentsdb.js';
import {flatten} from 'lodash';
import InstantViewSpritesheet from '@/ui/molecules/InstantViewSpritesheet.vue';
import { listPacksQuery } from '@/gql/Queries.js';
import { ApolloQuery } from 'vue-apollo';
import EditorPlayer from '@edit/organisms/EditorPlayer.vue';
import BackgroundAnimator from '@ui/molecules/BackgroundAnimator.vue';

export default {
  props: {
    partutil: {
      type: Object,
      required: true
    },
    transformsAndSource: {
      type: Object,
      required: true
    },
    renderTools: {
      type: Object,
      required: true
    },
    holderData: {
      type: Object,
      required: true
    }
  },
  data() {
    const layer = {
      id: 'background',
      name: 'Background',
      projection: 'background',
      zindex: -1,
      direction: 'rightdown'
    };
    const gamedata = this.partutil.gamedata.gamedata;
    if (typeof(gamedata.uploadedImages) === 'undefined') {
      this.$set(gamedata, 'uploadedImages', []);
    }
    const uploadedImages = gamedata.uploadedImages;
    const backgroundInfo = this.getBackgroundInfo();
    return {
      listPacksQuery,
      colors,
      layer,
      waitingForBackgroundToLoad: false,
      uploadedImages,
      backgroundInfo,
      mode:backgroundInfo.type === 'transform' ? 'image' : 'color'
    }
  },
  components: {
    EditorPlayer,
    InstantViewSpritesheet,
    ImageUploader,
    ApolloQuery,
    BackgroundAnimator
  },
  methods: {
    onUpload(data) {
      this.uploadedImages.push(data);
    },
    onSelectUploadedImage({id}) {
      this.$emit("clear-layer", this.layer);
      const position = {
        x: 0,
        y: 0
      }

      const {newChildren,newParents,newComponents} = this.partutil.addTilingSpriteFromSpritesheet({
        layer:this.layer,
        image:{id},
        position,
      });

      const component = newComponents[0];
      const transform = newChildren[0];

      this.waitingForBackgroundToLoad = true;
      this.renderTools.addOnReadyEvent(newChildren[0], (holder) => {
        console.log('scaling cover');
        holder.scaleCover();
        this.renderTools.addToRunBatch( () => {
          this.renderTools.addToUpdateBatch(holder);
          this.waitingForBackgroundToLoad = false;
          this.backgroundInfo = this.getBackgroundInfo();
          this.$refs.player.restartGame();

        });
      });

      /*this.$ana.track({
        eventCategory: 'instant',
        eventAction: 'uploaded',
        extra: {
          id
        }
      });*/
    },
    clearBackground() {
      this.$emit("clear-layer", this.layer);
      this.$set(this.partutil.gamedata.gamedata.game, 'bgcolor', '0x313131');
      this.$set(this.transformsAndSource.gamedata.gamedata.game, 'bgcolor', '0x313131');
      this.$refs.player.restartGame();
    },
    selectColor(color) {
      this.$emit("clear-layer", this.layer);
      this.$set(this.partutil.gamedata.gamedata.game, 'bgcolor', color);
      this.$set(this.transformsAndSource.gamedata.gamedata.game, 'bgcolor', color);
      this.$refs.player.restartGame();
      this.backgroundInfo = this.getBackgroundInfo();
    },
    onSelectBackgroundImage({image,spritesheet}) {
      this.$emit("clear-layer", this.layer);
      const position = {
        x: 0,
        y: 0
      }

      const autotoys = [
        {
          name:"__default",
          transform:{
            scalemethod:"cover",
            pos:{
              x:0,
              y:0
            }
          }
        }
      ]

      this.waitingForBackgroundToLoad = true;
      if (false && this.backgroundInfo.type === 'transform') {
        const {transform,component} = this.backgroundInfo;
        console.log('update component', component);
        Object.assign(component, {
          atlas:spritesheet,
          texture:image.name,
          sprite:image.name,
          firstLoad:true
        }); 
        this.$set(component, 'sprite', image.name);
        this.renderTools.addOnAutoScaleEvent(transform, (holder) => {
          console.log('auto scale event', holder);
          holder.scaleCover();
          this.renderTools.addToRunBatch( () => {
            this.renderTools.addToUpdateBatch(holder);
            this.renderTools.addToRunBatch( () => {
              this.waitingForBackgroundToLoad = false;
              this.backgroundInfo = this.getBackgroundInfo();
              this.$refs.player.restartGame();
            });
          });
        });
      } else {
        this.partutil.addTilingSpriteFromSpritesheet({
        //this.partutil.addImageFromSpritesheet({
          image,
          spritesheet,
          layer:this.layer,
          position,
          renderTools:this.renderTools,
          autotoys
        }, ({component,transform}) => {
          console.log('newComponents', component);
          console.log('transform scale', transform.transform.localScale.x, transform.transform.localScale.y);
          this.waitingForBackgroundToLoad = false;
          this.backgroundInfo = this.getBackgroundInfo();
          this.$refs.player.restartGame();
        });
      }
    },
    onAddBackground() {
      this.$emit('done');
    },
    onClose() {
      this.$emit('close');
    },
    getBackgroundsFromPacks(packs) {
      console.log('packs', packs);
      let backgrounds = packs.filter( ({id}) => {
        return id.includes('background');
      }).map( ({items}) => {
        return items.map( ({toysheets}) => {
          return toysheets;
        });;
      });
      backgrounds = flatten(backgrounds);
      backgrounds = flatten(backgrounds);
      backgrounds = flatten(backgrounds.map( ({spritesheets}) => {
        return spritesheets
      }));
      backgrounds = flatten(backgrounds.map( ({spritesheet}) => {
        return spritesheet
      }));
      console.log('backgrounds', backgrounds);
      return backgrounds;
    },
    getBackgroundInfo() {
      const backgroundTransforms = this.partutil.getTransformsByLayer('background');
      if (backgroundTransforms.length) {
        const transform = backgroundTransforms[0];
        const component = this.partutil.findComponentForTransform(transform);
        return {
          type:'transform',
          transform,
          component
        }
      } else {
        return {
          type: 'color'
        }
      }
    },
    onRestart() {
      this.$refs.player.restartGame();
      this.backgroundInfo = this.getBackgroundInfo();
    }
  },
  watch:{
  },
  computed: {
    isColor: {
      get() {
        return this.mode === 'color'
      },
      set(nv) {
        this.mode = 'color';
      }
    },
    isImage: {
      get() {
        return this.mode === 'image';
      },
      set(nv) {
        this.mode = 'image';
      }
    }
  }
}
</script>
<style>
</style>

